import { Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ErrorPage from '@/views/pages/404Page';
import { GuardedPageRoute } from '../routeGuards';
import {
  CreatePackagePage,
  CreateSerialPage,
  EditPackagePage,
  EditSerialPage,
  ImportPackagePage,
  ImportSerialPage,
  PackageHistoryPage,
  PackagePage,
  PackageMarkupPage,
  SortPackagesPage,
} from '../lazyPages';

export const PackageRoutes = () => {
  const { t } = useTranslation();
  return (
    <Routes>
      <Route
        index
        element={
          <GuardedPageRoute pageName={t('STAFF_SIDEBAR.PACKAGE_LIST')}>
            <PackagePage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="create"
        element={
          <GuardedPageRoute pageName={t('CREATE_PACKAGE')} action="create">
            <CreatePackagePage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="edit/:id"
        element={
          <GuardedPageRoute pageName={t('PACKAGE.EDIT.TITLE')} action="update">
            <EditPackagePage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="import"
        element={
          <GuardedPageRoute
            pageName={t('PACKAGE.IMPORT_PACKAGE')}
            action="create"
          >
            <ImportPackagePage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="history/:id"
        element={
          <GuardedPageRoute pageName={t('PACKAGE.HISTORY.TITLE')}>
            <PackageHistoryPage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="serial/create"
        element={
          <GuardedPageRoute pageName={t('SERIAL.CREATE.TITLE')} action="create">
            <CreateSerialPage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="serial/import"
        element={
          <GuardedPageRoute
            pageName={t('PACKAGE.IMPORT_SERIAL.TITLE')}
            action="create"
          >
            <ImportSerialPage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="serial/edit/:id"
        element={
          <GuardedPageRoute pageName={t('SERIAL.EDIT.TITLE')} action="update">
            <EditSerialPage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="sort"
        element={
          <GuardedPageRoute pageName={t('PACKAGE.SORT.TITLE')} action="update">
            <SortPackagesPage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="markup"
        element={
          <GuardedPageRoute pageName={t('STAFF_SIDEBAR.PACKAGE_MARKUP')}>
            <PackageMarkupPage />
          </GuardedPageRoute>
        }
      />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};
